module.exports = __webpack_public_path__ + "static/img/14.f12a8a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/14.png
// module id = uVD4
// module chunks = 1